module.exports = __webpack_public_path__ + "img/6.bae9666e.png";